import { type TableParamsType } from '../../types/common';
import { type UseQueryResult, useQuery } from 'react-query';
import {
  TradePreClearanceService,
  TradePreClearanceSharedService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_TradePreClearanceRequestListDto,
} from '../../services/wealthlane-award-services';

const useGetPreClearanceRequestList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_TradePreClearanceRequestListDto | undefined,
  unknown
> => {
  const { approvalStatusIds, awardTypeId, filter, sorting, skipCount, maxResultCount } = tableInfo;
  const preClearanceRequestList = useQuery(
    [
      'getPreClearanceRequestList',
      approvalStatusIds,
      awardTypeId,
      filter,
      sorting,
      skipCount,
      maxResultCount,
    ],
    async () => {
      return await handleRequest(
        TradePreClearanceSharedService.getApiAwardApiAppTradePreClearancePreClearanceRequestList(
          approvalStatusIds,
          awardTypeId,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return preClearanceRequestList;
};

export default useGetPreClearanceRequestList;
